import { Breakpoints } from 'glints-aries/es/@next';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 70px);

  & > div {
    width: 664px;
    @media only screen and (max-width: ${Breakpoints.large}) {
      width: 100%;

      & > div > div:first-child {
        height: max-content;
      }

      br {
        display: none;
      }
    }
  }
`;
